/** 分享预览弹窗布局常量（设计稿外宽 663px，内容区 padding 24×2） */
export const SHARE_PREVIEW_MODAL_MAX_WIDTH_PX = 663;
export const SHARE_PREVIEW_MODAL_CONTENT_PADDING_PX = 48;
export const SHARE_PREVIEW_MODAL_VIEWPORT_MARGIN_PX = 32;
